import { Expose, Transform } from 'class-transformer'

import { ChapterStatusEnum } from '@interfaces/ChapterStatusEnum'

export class BookChapterType {
  @Expose() id: number

  @Expose({ name: 'runningNo' }) order: number

  @Expose() chapterName: string

  @Expose() chapterTitle: string

  @Expose() viewCount: number

  @Expose() commentCount: number

  @Expose() price: number

  @Expose() status: ChapterStatusEnum

  @Expose() createdAt: string

  @Expose() updatedAt: string

  @Expose() publishedAt: string

  @Expose() freeReadEndTime: string

  @Expose() chapterCoverImgPath: string

  @Expose() isPaid: boolean

  @Expose()
  @Transform(({ obj }) => {
    const datetime = new Date().valueOf()
    const publishedAt = new Date(obj.publishedAt).valueOf()

    return obj.status === ChapterStatusEnum.PUBLISHED && datetime < publishedAt
  })
  showPublishedAt: boolean

  @Expose()
  @Transform(({ value }) => value || 0)
  totalSales: number
}
